<template>
  <div class="homepage-banners">
    <div class="banner-img" :class="{'is-suite': isSuite}">
      <div v-if="banners.length > 1" id="banner" class="">
        <ol class="partner-bannerDot" v-show="isShowDot">
          <li v-for="(item, i) in banners" :key="i" ref="bannerDot"
              class="bannerDot" :class="{active: i==0}" @click="changeBanner(i)"></li>
        </ol>
        <!-- Wrapper for slides -->
        <swiper :options="swiperOptions" class="time-wrap" ref="bannerSwiper">
          <swiper-slide v-for="(banner, index) in banners" :key="index">
            <a class="bannerSwiper-pic" :href="banner.url" style="display:block; cursor: pointer;height: 100%;">
              <BannerVideoPlayer v-if="banner.videoUrl && banner.bannerType===2"
                          :videoUrl="banner.videoUrl"
                          :coverUrl="banner.image"
                          :fullScreenPlay="fullScreenPlay"
                          :isChange="isBannerChange"
                          :bannerIndex="1+index + '_banner_' + bannerSuffix"
                          :videoId="1+index"
                          />
              <img v-else :src="banner.image" width="100%">
            </a>

          </swiper-slide>
          <div class="banner-pagination" :class="{'is-suite': isSuite}" slot="pagination"></div>
        </swiper>
        <a v-if="banners.length > 1" class="left carousel-control" @click="goPrev()">
                        <span class="banner-arrow-icon banner-arrow-left" aria-hidden="true">
                            <img :src="leftArrowImg">
                        </span>
          <span class="sr-only">Previous</span>
        </a>


        <a v-if="banners.length > 1" class="right carousel-control" @click="goNext()">
                        <span class="banner-arrow-icon banner-arrow-right" aria-hidden="true">
                            <img :src="rightArrowImg">
                        </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div v-else-if="banners.length == 1">
        <a v-if="banners[0].url && banners[0].url.length > 0" :href="banners[0].url" style="display:block; cursor: pointer;">
          <img :src="banners[0].image" width="100%">
        </a>
        <div v-else class="bannerSwiper-pic">
          <BannerVideoPlayer v-if="banners[0].videoUrl && banners[0].bannerType===2"
                          :videoUrl="banners[0].videoUrl"
                          :coverUrl="banners[0].image"
                          :fullScreenPlay="fullScreenPlay"
                          :isChange="isBannerChange"
                          />
              <img v-else :src="banners[0].image" width="100%">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import BannerVideoPlayer from "@/components/Common/BannerVideoPlayer.vue";


export default {
  name: 'BannerDetail',
  components: {
    Swiper,
    BannerVideoPlayer,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    banners: {
      type: Array,
      default () {
        return []
        // {
        //     'image': 'required',
        //     'url': 'optional',
        //     'promoEndTime': 'optional',
        //     'showCountDown': false

        // }
      }
    },
    isSuite: {
      type: Boolean,
      default: false
    },
    isShowDot: {
      type: Boolean,
      default () {
        return false
      }
    },
    autoplay: {
      type: Boolean,
      default () {
        return false
      }
    },
    leftArrowImg: {
      type: String,
      default () {
        return 'https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-left-circular.png'
      }
    },
    rightArrowImg: {
      type: String,
      default () {
        return 'https://resource.rcclchina.com.cn/cruiseDetail/swiper/swiper-btn-right-circular.png'
      }
    },
    hasSpecBanner: {
      type: Boolean,
      default () {
        return false
      }
    },
    bannerSuffix: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    let autoplay = false
    if (this.autoplay) {
      autoplay = {
        delay: 5000
      }
    }
    return {
      swiperOptions: {
        // loop: true,
        speed: 500,
        autoplay: autoplay,
        pagination: {
          el: '.banner-pagination',
        },
        on: {
          slideChangeTransitionEnd: this.onBannerSliderChange,
          click: this.onBannerClick
        }
      },
      swiper: null,
      isBannerChange: null,
      fullScreenPlay: false
    }
  },
  mounted() {
    if (this.banners.length <= 1) {
      this.swiperOptions.loop = false
    }
    this.$nextTick(()=> {
      this.onBannerInit()
    })
  },
  methods: {
    isShowCountDown (item) {
      let now = new Date()
      const endTime = item.promoEndTime
      let checkEndTime = 0
      if (endTime && endTime.length > 0) {
        checkEndTime = (new Date(endTime.replace('T', ' '))).getTime()
        let result = item.showCountDown && checkEndTime > now.getTime()
        return result
      }
      return false
    },
    getCountDown (item) {
      const endTime = item.promoEndTime
      let checkEndTime = 0
      if (endTime && endTime.length > 0) {
        checkEndTime = (new Date(endTime.replace('T', ' '))).getTime()
      }
      return checkEndTime
    },
    goPrev () {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }
      this.swiper.slidePrev()
    },
    goNext () {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }
      this.swiper.slideNext()
    },
    onBannerInit () {
      if (this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
        if (this.autoplay && this.banners.length > 1) {
          this.swiper.autoplay.stop()
          this.swiper.autoplay.start()
        }
      }
    },
    onBannerSliderChange () {
      if(this.fullScreenPlay) return;
      this.isBannerChange = new Date().getTime().toString();
      // 获取所有bannerSwiper-pic元素
      const picElements = document.querySelectorAll('.bannerSwiper-pic')

      // 遍历每个pic元素，查找video标签并暂停播放
      picElements.forEach(picElement => {
        const videoElements = picElement.querySelectorAll('video')
        videoElements.forEach(video => {
          if (!video.paused) {
            video.currentTime = 0
            video.pause()
          }
        })
      })

      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper
      }

      if (this.swiper) {
        const index = this.swiper.realIndex
        if (this.isShowDot) {
          const dots = this.$refs.bannerDot
          dots.forEach(dot=> {
            dot.classList.remove('active')
          })
          dots[index].className += ' active'
        }
        // document.getElementById('cruiseDetailBannerIndex').innerHTML = this.swiper.realIndex + 1

        this.$emit('onBannerSliderChange', index)
      }
    },
    changeBanner (index) {
      if (this.swiper) {
        this.swiper.slideTo(index+1)
      }
    },
    onBannerClick () {
      if (this.swiper) {
        const index = this.swiper.realIndex
        this.$emit('onBannerClicked', index)

      }
    }
  },
  computed: {
    timing () {
      return "timing"
    },
  },
  watch: {
    banners (newValue) {
      console.log(newValue)
      if (newValue.length <= 1) {
        this.swiperOptions.loop = false
      } else {
        this.swiperOptions.loop = true
      }
    }
  }
}
</script>

<style lang="less" scoped>

.homepage-banners{
  position: relative;
  //height: 100%;
  height: 318px;
}

.homePage .homepage-banners{
  // height: 648px;
}

.homepage-banners .time-wrap {
  width: 100%;
  height: 100%;
}

.homepage-banners .carousel-inner {
  height: 100%;
}

.homepage-banners .carousel-inner .item {
  height: 100%;
}

.homepage-banners .banner-img{
  height: 100%;
  /* height: 648px;
  overflow: hidden; */
  & a.carousel-control {
    width: 12% !important;
  }
  & .carousel-control {
    height: 65%;
    top: 50%;
    transform: translateY(-50%);
  }

  &.is-suite {
    & a.carousel-control {
      width: 8% !important;
    }
    & .carousel-control {
      height: 70%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.homepage-banners .img.cruise-banner-image{
  width: initial;
  max-width: none;
  position: relative;
}

.homepage-banners .clock{
  width: 224px;
  height: 64px;
  position: absolute;
  left: 16.75%;
  top: 95px;
  border-radius: 34px;
  background: rgba(248, 0, 41, 0.8);
  display: block;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  box-sizing: border-box;
  text-align:center;
  padding-top: 3px;
}

.homepage-banners .clock .count-down-wrapper.timing {
  display: block;
}

.homepage-banners .clock .count-down-wrapper span:first-child{
  font-size:18px;
}
.homepage-banners .clock .count-down-wrapper span:nth-child(2){
  font-size: 14px;
}
.homepage-banners .clock .count-down-wrapper span span{
  position: relative;
  top: -2px;
}
.homepage-banners .clock .count-down-wrapper.timing span.num{
  color: #ffa70d;
  font-size: 24px;
  font-weight: 400;
}
.homepage-banners .saleArea{
  width: 696px;
  height: 284px;
  position: absolute;
  left: 20%;
  top: 20%;
  background: rgba(0,0,0,.6);
}

.homepage-banners .saleArea .tagbg{
  width: 158px;
  height: 24px;
  position: absolute;
  left: -5px;
  top: 10px;
  background: url('https://resource.rcclchina.com.cn/homePage/homePage-linebg.png') no-repeat 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
}
.homepage-banners .saleArea  .big-title{
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 29px;
  position: relative;
  top: 27px;
}
.homepage-banners .saleArea .text{
  font-size: 16px;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 10px;
  font-weight: 400;
}
.homepage-banners .saleArea .txt1>span{
  display: inline-block;
  width: 80px;
  height: 22px;
  border-radius: 20px;
  background: #ffa70d;
  font-size: 12px;
  color: #333;
  line-height: 22px;
  margin-left: 2px;
}
.homepage-banners .saleArea .txt1>span img{
  margin-left: 12px;
  margin-right: 3px;
  position: relative;
  top: -1px;
}
.homepage-banners .saleArea .txt2{
  margin-bottom: 15px;
}
.homepage-banners .saleArea .line{
  width:60px;
  height: 1px;
  margin-left: 30px;
  margin-bottom: 16px;
  background: #fbc500;;
}
.homepage-banners .saleArea .price{
  /* width: 402px; */
  display: block;
  justify-content: space-between;
  margin-left: 30px;
}
.homepage-banners .saleArea .price .tiny{
  display: inline-block;
  vertical-align: top;
}
.homepage-banners .saleArea .price .tiny span:first-child{
  color: #fff;
  font-size: 16px;
}
.homepage-banners .saleArea .price .tiny span:last-child{
  color: #fbc500;
  font-size: 16px;
  display: block;
}
.homepage-banners .saleArea .price .tiny span:last-child>i{
  font-style: normal;
  font-size: 30px;
  font-weight: bold;
}
.homepage-banners .saleArea .price .p-btn{
  display: block;
  width: 188px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: #282b2c;
  background: #fbc500;
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
}
.homepage-banners .saleArea .price .p-btn:hover{
  background: #f8de57;
}
.homepage-banners .banner-img a.carousel-control{
  width: 10%;
  opacity: 1;
  background: none;
}
.homepage-banners .carousel-control .banner-arrow-icon {
  display: block;
  width: 34px;
  height: 34px;
  margin-top: -17px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  z-index: 0;
}

.homepage-banners .carousel-control .banner-arrow-icon:active {
  opacity: .8;
}

.homepage-banners .carousel-control .banner-arrow-icon > img {
  vertical-align: inherit;
}

.homepage-banners .carousel-control .banner-arrow-left {
  left: 50%;
  margin-left: -17px;
}

.homepage-banners .carousel-control .banner-arrow-right {
  right: 50%;
  margin-right: -17px;
}


.partner-bannerDot {
  position: absolute;
  bottom: 10px;
  left: 0;
  z-index: 15;
  width: 100%;
  padding-left: 0;
  margin-left: 0;
  text-align: center;
  list-style: none;
}

.partner-bannerDot-up {
  bottom: 3px;
}

.partner-bannerDot .bannerDot {
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  height: 5px;
  cursor: pointer;

  border-radius: 2px;
  background-color: rgb(211, 218, 221);
  opacity: 0.702;
}

.partner-bannerDot .bannerDot:first-child{
  margin-right: 5px;
}

.partner-bannerDot .bannerDot.active {
  width: 55px;
  background-color: #ffcd00;
}

#banner {
  width: 100%;
  height: 100%;
  position: relative;
  .carousel-control {
    z-index: 1;
  }
}
.carousel-control.right-special{
  right:150px;
  left: auto;
}
.carousel-control.left-special{
  left:150px;
  right: auto;
}

.cruiseDetail-middle-banner {
  .partner-bannerDot {
    bottom: 0px;
    margin-bottom: 0px;
    left: 25%;
    margin-left: 0px;
    .bannerDot.active {
      background-color: #FFA230;
    }
  }
}
.specialBookingBanner{
  cursor: pointer;
}
</style>
<style lang="less">
.banner-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
  &.swiper-pagination-bullets {
    font-size: 0;
    line-height: 0;
    bottom: 30px;
    width: 60%;
    left: 50%;
    transform: translateX(-50%);
    & .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #FFFFFF;
      opacity: .6;
    }
    .swiper-pagination-bullet-active {
      border-radius: 6px;
      width: 16px;
    }
  }
  &.is-suite {
    font-size: 0;
    line-height: 0;
    height: 5px;
    width: 60%;
    left: 50%;
    transform: translateX(-50%);
    &.swiper-pagination-bullets {
      bottom: 42px;
      & .swiper-pagination-bullet {
        width: 30px;
        height: 1px;
        margin-top: 2px;
        border-radius: 1px;
        background: #0172B8;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        background: #ffffff;
        opacity: 1;
      }
    }
  }
}
</style>
